export default __webpack_public_path__ + "static/media/Map.93914889.png";